import { useEffect } from 'react';
import { ExamStatus } from 'models/exam-attempt';
/**
 *  Hook to restrict access for completed exams
 *  @param {ExamAttempt} attempt exam attempt.
 */
const useNavigateForCompletedExam = (attempt) => {
    useEffect(() => {
        if (attempt) {
            redirectIfCompleted(attempt);
        }
    }, [attempt]);
    const redirectIfCompleted = (examAttempt) => {
        var _a;
        if ((_a = examAttempt.status) === null || _a === void 0 ? void 0 : _a.includes(ExamStatus.COMPLETED)) {
            redirect(examAttempt.graded);
            return true;
        }
        const closingAt = examAttempt === null || examAttempt === void 0 ? void 0 : examAttempt.exam.closingAt;
        if (closingAt) {
            const isExpired = Date.now() > Date.parse(closingAt);
            if (isExpired) {
                redirect(examAttempt.graded);
                return true;
            }
        }
        return false;
    };
    const redirect = (graded) => {
        if (graded) {
            window.location.href = '/feedback';
        }
        else {
            window.location.href = '/finish';
        }
    };
    return { redirectIfCompleted };
};
export default useNavigateForCompletedExam;
